<!-- @format -->

<template>
	<div v-if="formStatus === 'widget'" class="placeholder"> 占位符 </div>
</template>

<script setup lang="ts">
	const formStatus = inject('form-status', 'widget');
</script>

<style scoped>
	.placeholder {
		display: flex;
		align-items: center;
		justify-content: center;
		height: 100%;
		width: 100%;
		border: 1px solid var(--el-border-color);
	}
</style>
